import React, { lazy } from 'react';
export function SolutionReveal() {
  return <section className="py-5 md:py-7 px-4 bg-white text-center overflow-hidden" data-id="element-176">
      <div className="max-w-4xl mx-auto" data-id="element-177">
        <div className="space-y-1 md:space-y-2 mb-4 md:mb-5" data-id="element-178">
          <h2 className="text-lg md:text-2xl font-bold text-text-primary/80" data-id="element-179">
            La solución no es cocinar mejor.
          </h2>
          <h3 className="text-2xl md:text-4xl font-black text-primary tracking-tight" data-id="element-180">
            Es cocinar menos.
          </h3>
        </div>

        <div className="bg-[#F7F5F0] text-text-primary p-4 md:p-6 shadow-sm relative max-w-2xl mx-auto border border-primary/20 rounded-2xl" data-id="element-181">
          <p className="text-xs md:text-sm font-bold text-primary uppercase tracking-widest mb-2 md:mb-3" data-id="element-182">
            Te presento:
          </p>
          <h4 className="text-2xl md:text-4xl text-text-primary mb-3 md:mb-4 font-black tracking-tight" data-id="element-183">
            SISTEMA 15D
          </h4>

          <div className="inline-flex flex-col items-center justify-center max-w-[180px] md:max-w-[200px] mx-auto bg-white border border-black/10 mb-3 md:mb-4 shadow-sm rounded-2xl p-3 md:p-4" data-id="element-184">
            <div className="w-10 h-10 md:w-12 md:h-12 bg-primary text-white flex items-center justify-center text-xl md:text-2xl font-bold mx-auto mb-2 md:mb-3 rounded-full" data-id="element-185">
              15D
            </div>
            <p className="font-heading text-sm md:text-base text-primary font-bold uppercase tracking-wide" data-id="element-186">
              El Método Oficial
            </p>
          </div>

          <div className="max-w-[240px] md:max-w-[300px] mx-auto mb-3 md:mb-4 rounded-2xl overflow-hidden shadow-lg" style={{
          minHeight: '240px'
        }} data-id="element-187">
            <img src="https://cdn.magicpatterns.com/uploads/kj9CCv6irhXFh56Fvwfq5u/Mockup_Ebook.png" alt="200 Recetas Inteligentes 15D — Ebook, app y planificador" width={600} height={600} className="w-full h-auto object-cover" loading="lazy" decoding="async" data-id="element-188" />
          </div>

          <p className="text-sm md:text-base font-medium text-text-primary/90 leading-relaxed" data-id="element-189">
            El método práctico para cocinar{' '}
            <span className="font-bold text-primary font-italic italic" data-id="element-190">
              2 horas cada 15 días
            </span>{' '}
            y olvidarte de la cocina diaria.
          </p>
        </div>
      </div>
    </section>;
}